// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".com-rank[data-v-7344b85f]{background-color:#fff!important}", ""]);
// Exports
module.exports = exports;
